"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _Grid = _interopRequireDefault(require("../common/Grid"));
var _Link = _interopRequireDefault(require("../common/Link"));
var _Container = _interopRequireDefault(require("../Container"));
var _emailUtils = require("../../../../utils/emailUtils");
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var SOCIALS = Object.entries({
  telegram: 'https://telegram.me/LevelTravelChatBot',
  vk: 'https://vk.com/im?sel=-29855322',
  facebook: 'https://www.facebook.com/messages/t/293609120687915',
  whatsapp: 'https://api.whatsapp.com/send?phone=79150424411',
  instagram: 'https://www.instagram.com/level.travel/'
});
var getFullPath = function getFullPath(socialName) {
  return (0, _emailUtils.getImage)("social/".concat(socialName, ".png"));
};
var SocialButtons = function SocialButtons() {
  var styles = {
    container: {
      fontSize: '14px',
      textAlign: 'center',
      color: _userflow["default"].colors.blackLight
    },
    buttonsContainer: {
      width: 'auto',
      margin: '0 auto'
    },
    offset: {
      padding: '0 6px'
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    style: styles.buttonsContainer
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, SOCIALS.map(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      name = _ref2[0],
      link = _ref2[1];
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
      style: styles.offset,
      key: name
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      href: link
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: getFullPath(name),
      width: "30",
      height: "30",
      alt: name,
      title: name
    })));
  }))));
};
var _default = exports["default"] = SocialButtons;